"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.agreementInfoApi = agreementInfoApi;
exports.agreementSaveApi = agreementSaveApi;
exports.cityListApi = cityListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
function unwrapRegionList(payload) {
  if (Array.isArray(payload)) return payload;
  if (!payload || _typeof(payload) !== 'object') return [];
  if (Array.isArray(payload.list)) return payload.list;
  if (Array.isArray(payload.data)) return payload.data;
  if (Array.isArray(payload.records)) return payload.records;
  if (Array.isArray(payload.children)) return payload.children;
  if (Array.isArray(payload.child)) return payload.child;
  if (Array.isArray(payload.childList)) return payload.childList;
  return [];
}
function normalizeRegionNode(node) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  if (!node || _typeof(node) !== 'object') return null;
  var normalizedNode = _objectSpread(_objectSpread({}, node), {}, {
    name: node.name || node.label || node.regionName || node.region_name || node.title || node.text || '',
    code: node.code !== undefined && node.code !== null && node.code !== '' ? node.code : node.value !== undefined && node.value !== null && node.value !== '' ? node.value : node.regionId !== undefined && node.regionId !== null && node.regionId !== '' ? node.regionId : node.region_id !== undefined && node.region_id !== null && node.region_id !== '' ? node.region_id : node.id !== undefined && node.id !== null && node.id !== '' ? node.id : node.adcode || node.areaCode || ''
  });
  var children = level >= 3 ? [] : unwrapRegionList(node.children || node.child || node.childList || node.regionList || []).map(function (item) {
    return normalizeRegionNode(item, level + 1);
  }).filter(Boolean);
  if (children.length) {
    normalizedNode.children = children;
  } else {
    delete normalizedNode.children;
  }
  return normalizedNode;
}
function normalizeRegionTree(payload) {
  return unwrapRegionList(payload).map(function (item) {
    return normalizeRegionNode(item);
  }).filter(function (item) {
    return item && item.name && item.code !== '';
  });
}

/**
 * @description 协议管理-- 详情
 */
function agreementInfoApi(data) {
  return _request.default.get("admin/platform/agreement/".concat(data));
}

/**
 * @description 协议管理-- 保存
 */
function agreementSaveApi(save, data) {
  // return request.post(`admin/platform/agreement/${save}`, data);
  return (0, _request.default)({
    url: "admin/platform/agreement/".concat(save),
    method: 'POST',
    data: data
  });
}
function cityListApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/city/region/list/tree',
    method: 'get',
    data: data
  }).then(function (res) {
    return normalizeRegionTree(res);
  });
}